import { render } from "./TheCard.vue?vue&type=template&id=03fb2f91&scoped=true"
import script from "./TheCard.vue?vue&type=script&lang=js"
export * from "./TheCard.vue?vue&type=script&lang=js"

import "./TheCard.vue?vue&type=style&index=0&id=03fb2f91&scoped=true&lang=css"

import exportComponent from "/Users/djones/Desktop/repos/davyjones-me/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03fb2f91"]])

export default __exports__